var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tenant-project-status float-left" }, [
    _c("span", [
      _vm._v(
        "\n    " +
          _vm._s(_vm.getDirStatus(_vm.currentDirectory, _vm.isTenant)) +
          "\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }